<button class="risk-score" (click)="toggleExpand()">
  <mat-icon>info_outline</mat-icon>
  <span>Risk score diagram</span>
  <div class="indicator" *ngIf="isExpanded">
    <div class="indicator-status low">
      <mat-icon>check_circle_outline</mat-icon>
      Low
    </div>
    <div class="indicator-status medium">
      <mat-icon>notifications_active</mat-icon>
      Medium
    </div>
    <div class="indicator-status high">
      <mat-icon>priority_high</mat-icon>
      High
    </div>
  </div>
</button>
